import { TThunkAction } from '../../../../common/types/thunk';
import { buyPackage } from '../../../services/buyPackage';
import { afterPurchasingPackageThunk } from '../afterPurchasingPackage';
import { path } from 'ramda';
import {
  selectActiveRecommendedPackage,
  selectRecommendedPackagePolygonIds,
  selectRecommendedPackagesAutoprolong,
  selectRecommendedPackageSource,
} from '../../../reducers/v2/recommendedPackages/selectors';

export const buyPackageThunk =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi }) => {
    const state = getState();

    const recommendedPackage = selectActiveRecommendedPackage(state);
    const autoProlong = selectRecommendedPackagesAutoprolong(state);
    const polygonIds = selectRecommendedPackagePolygonIds(state);
    const widgetSource = selectRecommendedPackageSource(state);

    const packageId = path<number>(['packageId'], recommendedPackage)!;

    const result = await buyPackage({ httpApi, packageId, autoProlong, polygonIds, widgetSource });

    dispatch(afterPurchasingPackageThunk(result));
  };
